import Sidebar from "../../components/sidebar/Sidebar";
import "./home.scss";
import FullScreenMap from "../../components/map/FullScreenMap";
import React, { useEffect, useState } from "react";
import Dashboard from "../../components/Dashboard/Dashboard";

const Home = (props) => {
  const [selectedTab, setSelectedTab] = useState("map");
  const [alarms, setAlarms] = useState([]);

  useEffect(() => {
    // Check if alarms is not empty
    if (alarms.length > 0) {
      setSelectedTab("map");
    } else {
      setSelectedTab("dashboard");
    }
  }, [alarms]);

  return (
    <div className="home">
      <div className="homeContainer">
        <FullScreenMap
          alarms={alarms}
          setAlarms={setAlarms}
          onAlarmsChange={setAlarms}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <Dashboard selectedTab={selectedTab} />
        <Sidebar />
      </div>
    </div>
  );
};

export default Home;
